import React from 'react';
import { Logo } from 'Components/Logo';
import { Markdown } from 'Components/Markdown';
import { FooterLinks } from './FooterLinks';
import './FooterContent.css';

export default function Footer({ links = null, social = null, legal = null, networkList = null }) {
  const defaultRenderer = {
    a: ({ href, children }) => (
      <a href={href} className="footerTrademarkLink" target="noopener noreferrer">
        {children}
      </a>
    ),
    p: ({ children }) => <p className="footerTrademarkText">{children}</p>,
  };
  return (
    <div className="footerContainer">
      {social && (
        <div className="footerSocialContainer">
          <FooterLinks className="footerSocialLinks" columns="4" {...social} inlineLinks hideLinkText />
        </div>
      )}

      {social && <hr className="footerBreakLine" />}

      <div className="footerLinksContainer">
        {links && <FooterLinks className="footerFoxNationLinks" {...links} />}
        {networkList && <hr className="footerBreakLine" />}
        {networkList && <FooterLinks className="footerFoxNetworkLinks" {...networkList} />}
      </div>

      {(links || networkList) && <hr className="footerBreakLine" />}

      {legal && (
        <div className="footerTrademarkContainer">
          <Logo className="footerLogo" width={55} height={55} />
          <Markdown className="footerTrademark" components={defaultRenderer}>
            {legal}
          </Markdown>
        </div>
      )}
      <div className="footerMobilePadding"></div>
    </div>
  );
}
